/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { teamSchema } from './teamSchema';

export const teamBulkCreateResponseSchema = z.object({
  createdCount: z.int(),
  skippedCount: z.int(),
  get teams() {
    return z.array(teamSchema);
  },
});
